/** OSS / DM downloads often omit MIME — browsers then force a Save dialog. */
export function asPdfBlob(blob: Blob, fileName?: string): Blob {
  if (blob.type === "application/pdf") return blob;
  const nameLooksPdf = (fileName ?? "").toLowerCase().endsWith(".pdf");
  const generic =
    !blob.type ||
    blob.type === "application/octet-stream" ||
    blob.type === "binary/octet-stream";
  if (nameLooksPdf || generic) {
    return new Blob([blob], { type: "application/pdf" });
  }
  return blob;
}
